import { useState } from 'react'

export default function AccordionSection({ title, icon, defaultOpen = false, badge, badgeVariant, sectionBg, children }) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className={`border-b-2 border-gray-300 dark:border-surface-dark-border ${sectionBg || ''}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-center justify-between hover:brightness-95 dark:hover:brightness-110 transition-colors"
      >
        <div className="flex items-center gap-2">
          <span className="text-lg">{icon}</span>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-200">{title}</h3>
          {badge && (
            <span className={`text-base px-2.5 py-0.5 rounded-full font-medium ml-2 ${
              badgeVariant === 'success'
                ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                : badgeVariant === 'warning'
                  ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
                  : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
            }`}>
              {badge}
            </span>
          )}
        </div>
        <span className={`text-gray-500 dark:text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div className="px-4 py-4">
          {children}
        </div>
      )}
    </div>
  )
}
